export const ENTITY = {
    DISPLAY: 'DISPLAY',
    NATIVE: 'NATIVE',
};

export const ENTITY_TO_PATH_MAP = {
    [ENTITY.DISPLAY]: 'display',
    [ENTITY.NATIVE]: 'native',
};
